import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export const AppContainerDiv = styled(Flexer.Parent).attrs(() => ({ flexDirection: 'column' }))`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const TopContainer = styled(Flexer.Child).attrs(() => ({ flex: '0' }))`
  position: relative;
  z-index: ${(props) => (props.elevated ? '300' : '99')};
`;

export const ContentContainer = styled(Flexer.Child).attrs(() => ({ flex: '1' }))`
  overflow: hidden;
  overflow-y: scroll;
  position: relative;

  &:has(.page-content-component) {
    overflow-y: hidden;
  }
`;
